import Tippy, { type TippyProps } from "@tippyjs/react/headless";
import { useCallback } from "react";

import styles from "./Tooltip.module.scss";

type TooltipProps = Omit<TippyProps, "render"> & {
  startDelay?: number;
};

type RenderAttrs = Parameters<Required<TippyProps>["render"]>[0];

export const Tooltip = ({ children, content, startDelay = 0, placement = "auto", ...restProps }: TooltipProps) => {
  const renderTippy = useCallback(
    (attrs: RenderAttrs) => (
      <div className={styles.tippy} tabIndex={-1} {...attrs}>
        {content}
      </div>
    ),
    [content],
  );

  return (
    <Tippy render={renderTippy} delay={[startDelay, 0]} placement={placement} {...restProps}>
      {children}
    </Tippy>
  );
};
